import {ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, Output} from '@angular/core';
import {WizardStep} from '../../wizard-step';
import {WizardGroup} from '../../wizard-group';

@Component({
    selector: 'wizard-navigation',
    styleUrls: ['./wizard-navigation.component.scss'],
    templateUrl: './wizard-navigation.component.html'
})
export class WizardNavigationComponent {
    /* Список групп с шагами визарда. Конкретные шаги уже находятся внутри групп. */
    @Input() groups: WizardGroup[] = [];

    /* Событие выбора шага */
    @Output() selectStep = new EventEmitter<WizardStep>();

    onStepClick(step) {
        this.selectStep.emit(step);
    }

    get visibleGroups(): WizardGroup[] {
        return this.groups.filter(group => group.visible);
    }
}
